import React, { useEffect, useState } from "react";
import { all_routes } from "../../router/all_routes";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import ProfileCard from "../common/profileCard";
import apiInstance from "../../../utility/apiInstance";
import { useSelector } from "react-redux";
import { Application } from "../../../core/types/types";
import { getCurrencySymbol } from "../../../utility/currencyUtils";
import ApplicationDetailsPopup from "./applicationDetailsPopup";
import RecruiterSidebar from "../common/recruiterSidebar";
import RecruiterStatusGate from "../common/recruiterStatusGate";

const RecruiterApplications = () => {
    const route = all_routes;
    const user = useSelector((state: any) => state.auth.user);
    const [applications, setApplications] = useState<[Application]>();

    const [applicationDetailsPopup, setApplicationDetailsPopup] = useState<boolean>(false);
    const [selectedApplication, setSelectedApplication] = useState<Application | null>(null);

    useEffect(() => {
        const fetchApplications = async () => {
            try {
                const response = await apiInstance.get("/api/applications", {
                    params: {
                        "where[student.agent][equals]": user.id, 
                    },
                });

                setApplications(response.data.docs);
            } catch (error) {
                console.error("Error fetching recruiter applications:", error);
            }
        };

        if (user?.id) {
            fetchApplications();
        }
    }, [user?.id]);


    return (
        <>
            <div className="content">
                <div className="container">
                    {/* profile box */}
                    <ProfileCard />
                    {/* profile box */}
                    <div className="row">
                        {/* sidebar */}
                        <RecruiterSidebar />
                        {/* sidebar */}
                        <div className="col-lg-9">
                            <RecruiterStatusGate>
                            <div className="page-title d-flex align-items-center justify-content-between">
                                <h5>Applications</h5>
                            </div>
                            <div className="table-responsive custom-table">
                                <table className="table">
                                    <thead className="thead-light">
                                        <tr>
                                            <th>Application ID</th>
                                            <th>Student</th>
                                            <th>Status</th>
                                            <th>Application Fee</th>
                                            <th>Program</th>
                                            <th>Institution</th>
                                            <th>Date</th>
                                            <th />
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {applications && applications?.length > 0
                                            ? applications?.map((item: Application) => (
                                                <tr>
                                                    <td>
                                                        <div
                                                            onClick={() => {
                                                                setSelectedApplication(item)
                                                                setApplicationDetailsPopup(true);
                                                            }}
                                                            className="text-primary fw-bold cursor-pointer"
                                                            
                                                        >
                                                            #{item.id.slice(-5)}
                                                        </div>
                                                    </td>
                                                    <td>{item?.student?.email || '-'}</td>
                                                    <td
                                                        className={
                                                            item?.status === "pending"
                                                                ? "text-warning fw-bold"
                                                                : item?.status === "in_review"
                                                                    ? "text-info fw-bold"
                                                                    : item?.status === "approved"
                                                                        ? "text-success fw-bold"
                                                                        : item?.status === "declined"
                                                                            ? "text-danger fw-bold"
                                                                            : ""
                                                        }
                                                    >
                                                        {item?.status || "pending"}
                                                    </td>
                                                    <td>{item?.applicationFee ? `${getCurrencySymbol(item?.institution?.country)}${item.applicationFee}` : 'Free'}</td>
                                                    <td
                                                        style={{
                                                            maxWidth: "150px",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                        title={item?.program?.programName || ''}
                                                    >
                                                        {item?.program?.programName || ''}
                                                    </td>
                                                    <td
                                                        style={{
                                                            maxWidth: "150px",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                        title={item?.institution?.schoolName || ''}
                                                    >
                                                        {item?.institution?.schoolName || ''}
                                                    </td>
                                                    <td>
                                                        {item?.createdAt ? new Date(item.createdAt).toLocaleDateString() : ''}
                                                    </td>                                                    
                                                </tr>
                                            ))
                                            : <tr><td colSpan={8} className="text-center">No applications</td></tr>}
                                    </tbody>
                                </table>
                            </div>
                            </RecruiterStatusGate>
                        </div>
                    </div>
                </div>
                <ApplicationDetailsPopup show={applicationDetailsPopup} onClose={() => setApplicationDetailsPopup(false)} application={selectedApplication} />
            </div>
        </>
    );
};

export default RecruiterApplications;
